<template>
  <section ref="sectionRef" class="core-container mt-8 animate-fadeIn relative">
    <slot />

    <NextModuleButton v-if="nextModule" @click.prevent="$emit('onNextModuleClick')" class="z-20">
      <div class="mt-4 text-center">
        {{ $t('general.save_and_go_to', { item: wtGeneral('navigation', nextModule) }) }}
      </div>
    </NextModuleButton>

    <NextStepButton v-if="nextStep" @click.prevent="$emit('onNextStepClick', sectionRef)" class="z-20"> </NextStepButton>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import NextStepButton from '@/components/partials/navigation/NextStepButton.vue'
import NextModuleButton from '@/components/partials/navigation/NextModuleButton.vue'
import { useWidgetText } from '@/helpers/useWidgetText'

const { wt: wtGeneral } = useWidgetText('widget-texts-general')
const sectionRef = ref<HTMLElement | null>(null)

defineProps({
  nextStep: { type: Boolean, required: false },
  nextModule: { type: String, required: false },
})
</script>

<style lang="postcss" scoped>
.core-container :deep(h2:first-child) {
  @apply mr-12;
}
</style>
